<template>
    <div>
        <p v-if="technicalError" class="text-red-500 italic pb-3">{{translations.technical_error}}</p>
        <p v-if="notFound" class="text-red-500 italic pb-3">{{translations.unable_to_find_order}}</p>
        <form @submit.prevent>
            <Input :error="errors['email']" class="basis pt-3 mb-3 px-4 md:p-0" idAttr="login_email" :label="translations.email_address" :placeholder="translations.email_address" v-model="form.email" />
            <template v-for="(order, index) in form.orders" :key="index">
                <div class="flex flex-col px-4 md:px-0">
                    <label :for="'external_id' + index" class="flex uppercase pb-3 text-base font-medium">
                        <span>{{ translations.order_number }}</span>
                        <button class="p-0 ml-auto text-blue-500" @click="deleteRow(index)" v-if="index != 0">Remove</button>
                    </label>
                    <input
                        v-model="order.external_id"
                        type="text"
                        :placeholder="translations.order_number"
                        :id="'external_id' + index"
                        :name="'external_id' + index"
                        class="mb-3 input"
                    >
                    <p v-if="order.error" class="text-red-500 text-sm pb-3 italic">{{ order.error }}</p>
                </div>
            </template>
            <div class="mx-4 md:m-0">
                <button v-if="this.form.orders.length == 1 && isReturn" @click="addRow()" class="block m-auto pt-0 pb-2 px-4 underline text-blue-400" type="button">{{ translations.login_add_order }}</button>
                <Button type="submit" :text="translations.login_button " class="mt-8 md:mt-12" @click="submit"/>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    props: ['translations', 'code', 'isReturn', 'isTest', 'testEmail', 'testExternalId'],
    data() {
        return {
            errors: [],
            notFound: false,
            technicalError: false,
            form: {
                email: this.testEmail ?? '',
                orders: [
                    {
                        external_id: this.testExternalId ?? '',
                        error: '',
                    },
                ],
            }
        }
    },
    methods: {
        addRow() {
            if(this.form.orders.length == 1) {
                this.form.orders.push({
                    external_id: '',
                    error: '',
                })
            }
        },
        deleteRow(index) {
            this.form.orders.splice(index,1)
        },
        resetState() {
            this.form.orders[0].error = ''
            if(this.form.orders[1]) {
                this.form.orders[1].error = ''
            }
            this.notFound = false
            this.technicalError = false
            this.errors = []
        },
        removeLetters() {
            let orders = []
            this.form.orders.forEach(order => {
                order.external_id = order.external_id.replace(/\D/g,'')
                orders.push(order)
            });
            return orders
        },
        async submit() {
            this.resetState()
            try {
                const { data, status } = await axios.post('/orders', {
                    email: this.form.email,
                    orders: this.removeLetters(),
                    errandTypeId: this.isReturn ? 1 : 2,
                    domain: this.code,
                    isTest: this.isTest
                })
                if(status == 200) {
                    let isOrderData = false
                    //Make sure we have order data before continue otherwise show generic error
                    data.orders.forEach(order => {
                        order.filteredRows.forEach(row => {
                            if(Object.keys(row).length > 0) {
                                isOrderData = true
                            }
                        })
                    })
                    if(isOrderData) {
                        this.$emit('login', data)
                    }
                    else {
                        this.notFound = true
                    }
                }
            } catch (error) {
                if(error.response && error.response.status == 404) {
                    this.notFound = true
                }
                //422 for validation messages
                if(error.response && error.response.status == 422) {
                    const errors = error.response.data.errors
                    if(errors['orderDate']) {
                        //To find which order if multiple added that have expired return rights
                        this.findOrder(errors['orderDate'], 'order_expired')
                    }
                    else if(errors['maxQuantity']){
                        this.findOrder(errors['maxQuantity'], 'max_quantiy')
                    }
                    else if(errors['email']){
                        this.errors = errors
                    }
                    else {
                        //If not expired date or email it means either order wasn't found or not filled in
                        //We find which order that failed if multiple added
                        for (const property in errors) {
                            let index = this.getOrderIndexFromValidationMessages(property)
                            if(!index) {
                                this.notFound = true
                            } else {
                                this.form.orders[index].error = errors[property][0]
                            }
                        }
                    }
                }
                if(error.response && error.response.status == 500) {
                    this.technicalError = true
                }
            }
        },
        //Find the order index from the validation message key. Example orders.2.external_id => 2
        getOrderIndexFromValidationMessages(string) {
            var str = string;
            var matches = str.match(/(\d+)/);

            if (matches) {
                return matches[0];
            } else {
                return false
            }
        },
        findOrder(failedOrders, key) {
            failedOrders.forEach(failedOrder => {
                this.form.orders.forEach(order => {
                    if(order.external_id == failedOrder) {
                        order.error = this.translations[key]
                    }
                })
            })
        },
        checkIfCookieIsSet(name) {
            const match = document.cookie.match(new RegExp('(^| )XSRF-TOKEN=([^;]+)'));
            if (!match) {
                location.reload()
            }
        },
    },
    mounted() {
        if(!this.isTest) {
            this.checkIfCookieIsSet()
        }

        // this.submit()
    }
};
</script>


<style lang="scss" scoped>
.email {
    margin-bottom: 2.2rem;
    label {
        margin-bottom: 0.55rem;
    }
}
input {
    padding: 0.83rem;
}
button.steps {
    margin-top: 3rem;
    padding: 0.88rem;
}
</style>
